var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CountryFlag',{attrs:{"country":_vm.country}})
}
var staticRenderFns = []

export { render, staticRenderFns }